import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import { QuickActionMenuItem } from "./QuickActionMenuItem";

interface Props {
  visible: boolean;
  enabled: boolean;
  onLoad: () => void;
}

export const LoadAllPnAButton = ({ visible, enabled, onLoad }: Props) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <QuickActionMenuItem>
      <LinkButton
        iconBefore={<AutorenewOutlinedIcon />}
        onClick={onLoad}
        data-test-id={"btn-load-all-pna"}
        disabled={!enabled}
      >
        {t("cartPage.btn.loadAllPnA")}
      </LinkButton>
    </QuickActionMenuItem>
  );
};
